export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const imgFallback = (url) => (e) => {
  if (e.currentTarget.src !== url) e.currentTarget.src = url;
};
